export default "__VITE_ASSET__Cpbdru3m__"